import React, { Component } from 'react';
import { Select } from 'antd';
import { AntSelect } from './selects';

const isoSelect = AntSelect(Select);
const SelectOption = Select.Option;

export default disabledTextSelect(isoSelect);
export { SelectOption };

function disabledTextSelect(WrappedSelect) {
  return class Select extends Component {
    disableInput() {}
    componentDidMount() {
      this.disableInput();
    }
    render() {
      return <WrappedSelect {...this.props} />;
    }
  };
}



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/oms/PackageOrderDetail/modals/manuelPackage/Select/index.js